<template>
	<div class="shop-body open-shop">
		<div class="shop-main">
			<!-- left -->
			<div class="shop-main-left">
				<!-- title -->
				<p class="shop-main-left-title">{{ $t("openvippackage") }}</p>
				<!-- 套餐选择 -->
				<div class="shop-main-left-choose">
					<div
						class="shop-main-left-choose-box"
						:class="{'shop-main-left-box-bechoosed': isChoosed0}"
						@click="changeChoose('isChoosed0', '88', 305)"
					>
						<div class="shop-main-left-choose-box-text">
							<span>￥</span><span>88</span><span>/{{ $t("lifelong") }}</span>
						</div>
						<!-- 超值套餐 -->
						<div class="shop-main-left-choose-box-sup">
							<span>{{ $t("supervalue") }}</span>
						</div>
						<!-- 右下角角标 -->
						<!-- <div class="shop-main-left-choose-box-sub"></div> -->
					</div>
					<div
						class="shop-main-left-choose-box"
						:class="{'shop-main-left-box-bechoosed': isChoosed1}"
						@click="changeChoose('isChoosed1', '68', 304)"
					>
						<div class="shop-main-left-choose-box-text">
							<span>￥</span><span>68</span><span>/12{{ $t("months") }}</span>
							<p>{{ $t("just") }}<span>5.6</span>{{ $t("yuanmonth") }}</p>
						</div>
					</div>
					<div
						class="shop-main-left-choose-box"
						:class="{'shop-main-left-box-bechoosed': isChoosed2}"
						@click="changeChoose('isChoosed2', '48', 532)"
					>
						<div class="shop-main-left-choose-box-text">
							<span>￥</span><span>48</span><span>/1{{ $t("months") }}</span>
						</div>
					</div>
				</div>
				<!-- 付款 -->
				<div class="shop-main-left-pay">
					<!-- 付款二维码 -->
					<div class="shop-main-left-pay-left">
						<div class="shop-main-left-pay-left-erweima">
							<img
								:src="payQrcode"
								alt=" "
								@load="
									() => {
										isImgReady = true;
									}
								"
							/>
							<div
								:class="
									isImgReady
										? 'shop-main-left-pay-left-erweima-default'
										: 'shop-main-left-pay-left-erweima-load'
								"
							></div>
						</div>
						<div class="shop-main-left-pay-left-logo">
							<img src="../../mycomponents/img/shop/sty weixin.svg" alt="" />
							<img src="../../mycomponents/img/shop/syt zfb.svg" alt="" />
							<span>{{ $t("codescanningpayment") }}</span>
						</div>
					</div>
					<!-- 要支付的金额 -->
					<div class="shop-main-left-text">
						<p>
							<span>{{ $t("paymentamount") }}</span
							><span>￥</span><span>{{ boxPrice }}</span>
						</p>
						<a @click="zfbPay">{{ $t("clickonalipaypaymentpage") }}</a>
					</div>
				</div>
			</div>
			<!-- right -->
			<div class="shop-main-right">
				<!-- 关闭 -->
				<div class="shop-main-right-close" @click="closeShop"></div>
				<!-- title -->
				<p class="shop-main-right-title">{{ $t("enjoymemberprivileges") }}</p>
				<!-- main -->
				<div class="shop-main-right-main">
					<div class="shop-main-right-main-box">
						<div class="shop-main-right-main-logo"></div>
						<span>{{ $t("text019") }}</span>
					</div>
					<div class="shop-main-right-main-box">
						<div class="shop-main-right-main-logo"></div>
						<span>{{ $t("text020") }}</span>
					</div>
					<div class="shop-main-right-main-box">
						<div class="shop-main-right-main-logo"></div>
						<span>{{ $t("text021") }}</span>
					</div>
					<div class="shop-main-right-main-box">
						<div class="shop-main-right-main-logo"></div>
						<span>{{ $t("text022") }}</span>
					</div>
					<div class="shop-main-right-main-box">
						<div class="shop-main-right-main-logo"></div>
						<span>{{ $t("unlimitedfilesizecompressionwill") }}</span>
					</div>
					<div class="shop-main-right-main-box">
						<div class="shop-main-right-main-logo"></div>
						<span>{{ $t("losslesscompressionlargefiles") }}</span>
					</div>
					<div class="shop-main-right-main-box">
						<div class="shop-main-right-main-logo"></div>
						<span>{{ $t("upto90lessstorage") }}</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import config from "../../plugins/config";
import Detain from "./Detain.vue";
import {paymerge, payorderstatedetails, payorder} from "../../plugins/sdk";
export default {
	data() {
		return {
			isChoosed0: true,
			isChoosed1: false,
			isChoosed2: false,
			boxPrice: "88",
			checkedId: 305,
			checkedObj: config.PAY_PACKAGES[0],
			taocanObj: config.PAY_PACKAGES,
			payQrcode: "",
			timerPayState: "",
			isImgReady: false,
			zfbSrc: "",
		};
	},
	computed: {
		userData() {
			return this.$local.userLoginData;
		},
	},
	methods: {
		// 点击右上角关闭关闭shop
		async closeShop(flag) {
			clearInterval(this.timerPayState);
			await this.$app.getUserInfo();
			for (let item in config.PAY_PACKAGES) {
				config.PAY_PACKAGES[item].res = "";
			}
			// if (this.$app.VIPlevel != 2) {
			// 	this.checkDayOver();
			// 	if (this.$local.detainData.detainTime > 0) {
			// 		await this.$dlg.show(Detain);
			// 	}
			// }
			this.$emit("close", flag);
		},
		// 切换点击的choose-box
		changeChoose(str, pri, idNum) {
			console.log(str);
			this.boxPrice = pri;
			this.checkedId = idNum;
			this.checkedObj = this.taocanObj.find((item) => item.realId === this.checkedId);
			this.payCreate();
			this.isChoosed0 = false;
			this.isChoosed1 = false;
			this.isChoosed2 = false;
			switch (str) {
				case "isChoosed0":
					this.isChoosed0 = true;
					break;
				case "isChoosed1":
					this.isChoosed1 = true;
					break;
				case "isChoosed2":
					this.isChoosed2 = true;
					break;
			}
		},
		// 请求接口部分
		// 获取当前选择订单的支付二维码
		payCreate() {
			let item = this.taocanObj.find((item) => item.realId == this.checkedId) || {};
			console.log("我选中的套餐", item);
			if (item.res) {
				this.payCreateFun(item.res);
				return;
			}
			paymerge({
				account: this.userData.username,
				productinfo: this.checkedObj.paypack,
				width: 159,
				iflogo: 0,
			}).then((res) => {
				console.log("请求二维码返回的数据", res);
				if (res.code == 10000) {
					item.res = res;
					this.payCreateFun(res);
				}
			});
		},
		payCreateFun(res) {
			this.payQrcode = res.qrcode;
			clearInterval(this.timerPayState);
			this.timerPayState = setInterval(() => {
				this.payState(res.orderno);
			}, 3000);
		},
		//更新支付状态
		payState(orderno) {
			payorderstatedetails({
				account: this.userData.username,
				orderno,
			})
				.then((res) => {
					console.log("该订单是否支付", res);
					if (res) {
						clearInterval(this.timerPayState);
						// registerOCPC(this.$local.userLoginData);
						return this.$app.getUserInfo().then(() => {
							//支付埋点
							if (this.$app.VIPlevel === 2) {
								window.gevt("SKU_88", "支付事件", this.$app.theWayToShop, "None", "None", "None");
							} else if (this.$app.VIPlevel === 3) {
								window.gevt("SKU_68", "支付事件", this.$app.theWayToShop, "None", "None", "None");
							} else if (this.$app.VIPlevel === 1) {
								window.gevt("SKU_48", "支付事件", this.$app.theWayToShop, "None", "None", "None");
							}
							//支付成功关闭shop模态框并回调
							this.closeShop(true);
						});
					} else {
						this.$toast.error(this.$t("paymentfail"));
					}
				})
				.catch((err) => {
					console.log("未支付", err);
				});
		},
		checkDayOver() {
			console.log("1");
			let time1 = new Date();
			let time2 = new Date();
			if (this.$local.detainData) {
				if (this.$local.detainData.lostLogin_Time)
					time2.setTime(this.$local.detainData.lostLogin_Time);
				console.log("time2", time2);
			}
			if (!this.$local.detainData) {
				let a = {
					lostLogin_Time: time1.getTime(),
					detainTime: 3,
				};
				this.$local.detainData = a;
				console.log("2");
			} else if (
				time1.getDate() == time2.getDate() &&
				time1.getTime() > time2.getTime() &&
				time1.getMonth() == time2.getMonth()
			) {
				this.$local.detainData.detainTime = this.$local.detainData.detainTime - 1;
			} else if (
				(time1.getDate() > time2.getDate() || time1.getMonth() > time2.getMonth()) &&
				time1.getTime() > time2.getTime()
			) {
				console.log("4");
				this.$local.detainData.detainTime = 3;
				this.$local.detainData.lostLogin_Time = time1.getTime();
			}
		},
		// 点击打开支付宝订单监听
		zfbPay() {
			window.gevt("点击进入支付宝付款页面", "点击事件", "收银台", "None", "None", "None");
			clearInterval(this.timerPayState);
			let item = this.taocanObj.find((item) => item.realId == this.checkedId) || {};
			if (item.zfbsrc) {
				return;
			}
			let data = {
				orderpackinfo: item.zfbpaypack,
				account: this.$local.userLoginData.username,
				paymethod: "alipay",
			};
			payorder(data).then((res) => {
				console.log("支付宝地址获取", res);
				var a = document.createElement("a");
				a.href = res.paygateway;
				a.target = "_blank";
				a.click();
				a.remove();
				let _this = this;
				this.timerPayState = setInterval(() => {
					_this.payState(res.orderno);
				}, 3000);
			});
		},
	},
	mounted() {
		this.changeChoose("isChoosed0", "88", 305);
		// window.gevt("收银台展示量", "收银台事件", "None", "None", this.$app.VIPState, "None");
	},
};
</script>

<style lang="less">
/* body */
.shop-body {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.4);
	z-index: 9998;
	display: none;
}

/* main */
.shop-main {
	height: 528rem;
	width: 946rem;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	overflow: hidden;
}
.shop-main::after {
	content: "";
	display: inline-block;
	height: 100%;
	vertical-align: middle;
}
/* left */
.shop-main-left {
	display: inline-block;
	vertical-align: middle;
	width: 590rem;
	height: 527rem;
	border-radius: 8rem 0 0 8rem;
	background: #ffffff;
	box-sizing: border-box;
	padding: 43rem 24rem 40rem 24rem;
}
/* titl */
.shop-main-left-title {
	font-size: 24rem;
	font-family: MicrosoftYaHei-Bold;
	color: #333333;
	opacity: 1;
	margin-bottom: 32rem;
}
/* 套餐选择 */
.shop-main-left-choose {
	margin-bottom: 24rem;
}
.shop-main-left-choose-box {
	height: 140rem;
	width: 170rem;
	display: inline-block;
	box-sizing: border-box;
	vertical-align: middle;
	border-radius: 10rem;
	border: 1rem solid #e2e2e2;
	text-align: center;
	position: relative;
	cursor: pointer;
}
.shop-main-left-choose-box::after {
	content: "";
	display: inline-block;
	height: 100%;
	vertical-align: middle;
}
/* .shop-main-left-choose-box:nth-of-type(1) {
	border: 2rem solid #bc9535;
	background: #f8f7ec;
} */
.shop-main-left-choose-box:nth-of-type(1),
.shop-main-left-choose-box:nth-of-type(2) {
	margin-right: 16rem;
}
.shop-main-left-choose-box-text {
	position: relative;
	display: inline-block;
	vertical-align: middle;
}
/* .shop-main-left-choose-box:nth-of-type(1) .shop-main-left-choose-box-text span {
	color: #bb9127 !important;
} */
.shop-main-left-choose-box-text span:nth-of-type(1) {
	font-size: 21rem;
	font-family: MicrosoftYaHei-Bold;
	color: #1b212e;
	opacity: 1;
}
.shop-main-left-choose-box-text span:nth-of-type(2) {
	font-size: 45rem;
	font-family: Arial;
	font-weight: bold;
	color: #1b212e;
	opacity: 1;
}
.shop-main-left-choose-box-text span:nth-of-type(3) {
	font-size: 14rem;
	font-family: Microsoft YaHei;
	font-weight: 400;
	color: #364159;
	opacity: 1;
}
.shop-main-left-choose-box-text p {
	position: absolute;
	font-size: 14rem;
	font-family: MicrosoftYaHei;
	color: #b57828;
	opacity: 1;
	left: 20rem;
}
.shop-main-left-choose-box-text p span:nth-of-type(1) {
	font-size: 14rem;
	font-family: MicrosoftYaHei;
	color: #b57828;
	opacity: 1;
}
/* 超值套餐  角标*/
.shop-main-left-choose-box-sup {
	position: absolute;
	left: 0;
	top: 0;
	background-image: url("../../mycomponents/img/shop/bg_skubq.svg");
	background-size: cover;
	height: 27rem;
	width: 81rem;
	/* border-radius: 11rem 0 0 0; */
	text-align: center;
}
.shop-main-left-choose-box-sup span {
	font-size: 16rem;
	font-family: Microsoft YaHei;
	font-weight: 400;
	color: #ffffff !important;
	opacity: 1;
}
.shop-main-left-box-bechoosed {
	border: 2rem solid #bc9535 !important;
	background: #f8f7ec !important;
}
.shop-main-left-box-bechoosed .shop-main-left-choose-box-text span {
	color: #bb9127 !important;
}
.shop-main-left-box-bechoosed::before {
	content: "";
	position: absolute;
	display: block;
	right: 0;
	bottom: 0;
	background-image: url("../../mycomponents/img/shop/icon_dg.svg");
	background-size: cover;
	height: 26rem;
	width: 27rem;
}

/* 付款 */
.shop-main-left-pay-left {
	width: 181rem;
	height: 215rem;
	border: 1rem solid #dfdddd;
	box-sizing: border-box;
	opacity: 1;
	border-radius: 8rem;
	padding: 11rem 11rem 0 11rem;
	display: inline-block;
	vertical-align: top;
}
/* left 付款二维码 */
.shop-main-left-pay-left-erweima {
	width: 159rem;
	height: 159rem;
	/* background-size: cover; */
	/* background-image: url("../../mycomponents/img/shop/二维码@2x.png"); */
	opacity: 1;
	margin-bottom: 11rem;
	position: relative;
}
.shop-main-left-pay-left-erweima img {
	height: 100%;
	width: 100%;
}
.shop-main-left-pay-left-erweima-default {
	position: absolute;
	width: 159rem;
	height: 159rem;
	top: 0;
	left: 0;
	transition: opacity 0.5s;
	opacity: 0;
}
.shop-main-left-pay-left-erweima-load {
	position: absolute;
	width: 159rem;
	height: 159rem;
	top: 0;
	left: 0;
	box-sizing: border-box;
	opacity: 1;
	transition: opacity 0.5s;
	box-sizing: border-box;
	background-repeat: no-repeat;
	background-size: 60rem, 60rem;
	background-position: center center;
	background-image: url("../../mycomponents/img/login/微信二维码等待.gif");
}
.shop-main-left-pay-left-logo {
	height: 22.68rem;
	text-align: center;
}
.shop-main-left-pay-left-logo::after {
	content: "";
	display: inline-block;
	height: 100%;
	vertical-align: middle;
}
.shop-main-left-pay-left-logo img {
	display: inline-block;
	vertical-align: middle;
	height: 22.68rem;
	width: 22.68rem;
}
.shop-main-left-pay-left-logo img:nth-of-type(1) {
	margin-right: 11rem;
}
.shop-main-left-pay-left-logo span {
	vertical-align: middle;
	margin-left: 15rem;
	font-size: 16rem;
	font-family: MicrosoftYaHei;
	color: #5c7099;
	opacity: 1;
}
/* 付款金额 */
.shop-main-left-text {
	display: inline-block;
	vertical-align: top;
	/* margin-bottom: 5rem; */
	padding-top: 94rem;
	margin-left: 24rem;
}

.shop-main-left-text p span:nth-of-type(1) {
	font-size: 16rem;
	font-family: MicrosoftYaHei-Bold;
	color: #333333;
	opacity: 1;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15rem;
}
.shop-main-left-text p span:nth-of-type(2) {
	font-size: 24rem;
	font-family: MicrosoftYaHei-Bold;
	color: #bb9127;
	display: inline-block;
	vertical-align: middle;
	opacity: 1;
	position: relative;
	transform: translateY(-1rem);
}

.shop-main-left-text p span:nth-of-type(3) {
	font-size: 34rem;
	font-family: MicrosoftYaHei-Bold;
	color: #bb9127;
	opacity: 1;
	display: inline-block;
	vertical-align: middle;
	position: relative;
	transform: translateY(-3rem);
}

.shop-main-left-text a {
	/* width: 143rem;
	height: 18rem; */
	font-size: 13rem;
	font-family: Microsoft YaHei;
	font-weight: 400;
	/* line-height: 16rem; */
	color: #172f58;
	/* text-decoration: underline; */
	opacity: 1;
	cursor: pointer;
	&:hover {
		text-decoration: underline;
	}
}
/* right */
.shop-main-right {
	display: inline-block;
	vertical-align: middle;
	height: 528rem;
	width: 356rem;
	border-radius: 0 8rem 8rem 0;
	background-size: cover;
	background-image: url("./../../mycomponents/img/shop/bg@2x.png");
	box-sizing: border-box;
	padding: 179rem 0 0 43rem;
	position: relative;
}
.shop-main-right-title {
	font-size: 24rem;
	font-family: MicrosoftYaHei-Bold;
	color: #ffffff;
	opacity: 1;
	margin-bottom: 24rem;
}
.shop-main-right-main {
}
.shop-main-right-main-box {
	height: 20rem;
	margin-bottom: 19rem;
}
.shop-main-right-main-box::after {
	content: "";
	display: inline-block;
	vertical-align: middle;
	height: 100%;
}
.shop-main-right-main-logo {
	display: inline-block;
	vertical-align: middle;
	height: 16rem;
	width: 16rem;
	background-size: cover;
	background-image: url("../../mycomponents/img/shop/syt gx.svg");
	margin-right: 11rem;
}
.shop-main-right-main-box span {
	font-size: 14rem;
	font-family: MicrosoftYaHei;
	color: #ffffff;
	opacity: 1;
	display: inline-block;
	vertical-align: middle;
}
.shop-main-right-close {
	position: absolute;
	right: 12rem;
	top: 0;
	width: 24rem;
	height: 40rem;
	background-image: url("../../mycomponents/img/shop/icon_syt_gb01@2x (1).png");
	background-size: cover;
	cursor: pointer;
}

/* js */
.open-shop {
	display: block !important;
}
</style>
